import React from 'react';
import { Outlet } from 'react-router-dom';
import Nav from '../shared/Nav/Nav';

//for playing video
// document.getElementById('videoPlay').play();

const Main = () => {
   
    return (
        <div>
            <Nav></Nav>
            <Outlet></Outlet>
        </div>
    );
};

export default Main;